import React from "react";
import { observer } from "mobx-react";
import { Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

@observer
export class ClientsLayout extends React.Component<any, any> {
    render() {
        return <div>
            <Nav variant="tabs" defaultActiveKey="/clients/customers">
                <LinkContainer to="/clients/customers">
                    <Nav.Item>
                        <Nav.Link href="/clients/customers">Контрагенты</Nav.Link>
                    </Nav.Item>
                </LinkContainer>
            </Nav>

            <div>
                {this.props.children}
            </div>
        </div>;
    }
}